<template>
  <v-flex xs12>
    <v-data-table
      :items-per-page.sync="itemsPerPage"
      :page.sync="page"
      :headers="headers"
      :items="items"
      :loading="loading"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      must-sort
      loading-text="Loading... Please wait"
      v-sortable-data-table
      @sorted="dragReorder"
      :item-class.sync="sortableRow"
    >

      <template v-slot:top>
        <v-toolbar
          flat
        >
          <v-spacer></v-spacer>
          <v-dialog
            v-model="editdialog"
            max-width="75%"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                class="mx-2"
                color="primary"
                dark
                v-bind="attrs"
                v-on="on"
                fab
                small
              >
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <slot>
                      <v-icon
                        v-bind="attrs"
                        v-on="on"
                        dark
                      >
                        mdi-plus
                      </v-icon>
                    </slot>
                  </template>
                  create new playlist
                </v-tooltip>
              </v-btn>
            </template>
            <v-card>
              <v-card-title>
                <span class="headline">Playlist</span>
              </v-card-title>

              <v-card-text>
                <v-container>
                  <v-row>
                      <v-text-field
                        v-model="playlistItem.name"
                        label="Playlist name"
                      />
                  </v-row>
                  <v-row>
                      <v-text-field
                        v-model="playlistItem.title"
                        label="Playlist title"
                      />
                  </v-row>
                  <v-row>
                      <v-text-field
                        v-model="playlistItem.subtitle"
                        label="Playlist subtitle"
                      />
                  </v-row>
                </v-container>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="blue darken-1"
                  text
                  @click="editdialog = false"
                >
                  Cancel
                </v-btn>
                <v-btn
                  :loading="dialogupdating"
                  color="blue darken-1"
                  text
                  @click="save"
                >
                  Save
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </template>

      <template v-slot:item.ordering="{}">
        <v-btn icon
          class="sortHandle"
          :ripple="false"
        >
          <v-tooltip bottom :disabled="isSortable">
            <template v-slot:activator="{ on, attrs }">
              <slot>
                <v-icon
                  v-bind="attrs"
                  v-on="on"
                >
                  {{ isSortable
                  ? 'mdi-drag-horizontal-variant'
                  : 'mdi-cancel'}}
                </v-icon>
              </slot>
            </template>
            select table sort ascending by order field
          </v-tooltip>
        </v-btn>
      </template>

      <template v-slot:item.name="{ item }">
        <v-edit-dialog
          @save="updateItem(itemClone, item)"
          @open="itemClone = {...item}"
        >
        <div v-if="item.name" class="font-weight-black">{{ item.name }}</div>
        <div v-else class="font-italic font-weight-thin red--text" v-text="'empty'"/>
          <template v-slot:input>
            <v-text-field
              v-model="itemClone.name"
              label="Edit"
              single-line
              counter
            />
          </template>
        </v-edit-dialog>
      </template>

      <template v-slot:item.title="{ item }">
        <v-edit-dialog
          @save="updateItem(itemClone, item)"
          @open="itemClone = {...item}"
        >
          <div v-if="item.title" class="font-weight-black">{{ item.title }}</div>
          <div v-else class="font-italic font-weight-thin red--text" v-text="'empty'"/>
          <template v-slot:input>
            <v-text-field
              v-model="itemClone.title"
              label="Edit"
              single-line
              counter
            />
          </template>
        </v-edit-dialog>

        <translations-bar
          :id="item.id"
          :translations="translationsTitle[item.id] ? translationsTitle[item.id] : {}"
          :model="$constants.TRANSLATION_MODELS.PLAYLIST_TITLE"
          :title="item.title"
          :trigger-update="item.title"
        >
        </translations-bar>
      </template>

      <template v-slot:item.subtitle="{ item }">
        <v-edit-dialog
          @save="updateItem(itemClone, item)"
          @open="itemClone = {...item}"
        >
          <div v-if="item.subtitle" class="font-weight-medium">{{ item.subtitle }}</div>
          <div v-else class="font-italic font-weight-thin red--text" v-text="'empty'"/>
          <template v-slot:input>
            <v-text-field
              v-model="itemClone.subtitle"
              label="Edit"
              single-line
              counter
            />
          </template>
        </v-edit-dialog>

        <translations-bar
          :id="item.id"
          :translations="translationsSubtitle[item.id] ? translationsSubtitle[item.id] : {}"
          :model="$constants.TRANSLATION_MODELS.PLAYLIST_SUBTITLE"
          :title="item.subtitle"
          :trigger-update="item.subtitle"
        >
        </translations-bar>
      </template>

      <template v-slot:item.status="{ item }">
        <TripleButton
          :status="item.status"
          @pressed="triplePressed($event, item)"
        />

      </template>

      <template v-slot:item.actions="{ item }">
        <v-btn icon :to="`playlist/${item.id}`">
          <v-icon
            color="orange"
          >
            mdi-pen
          </v-icon>
        </v-btn>

        <v-btn
          v-if="!hasSomeAbilities($constants.ABILITY.INTERN)"
          icon @click="deleteDialog(item.id)"
        >
          <v-icon
            color="red"
          >
            mdi-delete
          </v-icon>
        </v-btn>
      </template>
    </v-data-table>
  </v-flex>
</template>

<script>
import { mapActions } from 'vuex';
import Sortable from 'sortablejs';
import TripleButton from '../components/TripleButton.vue';
import TranslationsBar from '../components/Translations/TranslationsBar.vue';

export default {
  name: 'PlaylistPoi',
  components: {
    TranslationsBar,
    TripleButton,
  },
  data() {
    return {
      itemsPerPage: 10,
      page: 1,
      isSortable: true,
      sortBy: 'order',
      sortDesc: false,
      editdialog: false,
      dialogupdating: false,
      playlistItem: {
        name: '',
        title: '',
        subtitle: '',
        order: null,
      },
      itemClone: {},
      loading: true,
      items: [],
      headers: [
        {
          text: '',
          sortable: false,
          value: 'ordering',
          align: 'center',
        },
        {
          text: 'order',
          value: 'order',
          align: 'center',
        },
        { text: 'id', value: 'id' },
        { text: 'name (deprecated)', value: 'name' },
        { text: 'subtitle', value: 'subtitle' },
        { text: 'title', value: 'title' },
        { text: 'status', value: 'status' },
        { text: '', value: 'actions', sortable: false },
      ],
      translationsSubtitle: {},
      translationsTitle: {},
    };
  },

  watch: {
    editdialog() {
      this.playlistItem = {
        name: '',
        title: '',
        subtitle: '',
        order: null,
      };
    },
  },

  created() {
    this.$requestHelpers
      .get('api/admin/playlistpoi')
      .then((response) => {
        if (this.isNeedToFixSortedArrayOrder(response.data.items)) {
          this.items = this.adjustArrayOrder(response.data.items);
          this.updateItemsOrder();
        } else {
          this.items = response.data.items;
        }

        this.loading = false;
        this.getTranslationsSubtitle();
        this.getTranslationsTitle();
      });
  },

  methods: {
    ...mapActions({
      setSnack: 'snackbar/setState',
    }),

    save() {
      this.playlistItem.order = this.maxOrder + 1;
      this.dialogupdating = true;
      this.$requestHelpers
        .post('api/admin/playlistpoi', this.playlistItem)
        .then((response) => {
          if (response.data.success) {
            this.setSnack({
              color: 'green',
              text: 'saved',
            });
            this.items.push(response.data.result);
            this.editdialog = false;
            this.getTranslationsSubtitle();
            this.getTranslationsTitle();
          }
        }).finally(() => {
          this.dialogupdating = false;
        });
    },

    updateItem(itemClone, item) {
      const origItem = { ...item };

      this.$requestHelpers
        .patch(`api/admin/playlistpoi/${itemClone.id}`, itemClone)
        .then((response) => {
          if (response.data.success) {
            this.setSnack({
              color: 'green',
              text: 'saved',
            });
          }

          Object.assign(item, response.data.result);
        }).catch(() => {
          Object.assign(item, origItem);
        });
    },

    deleteDialog(id) {
      this.$confirm('Are you sure you want to delete this item?').then((res) => {
        if (!res) return;
        this.$requestHelpers
          .delete(`api/admin/playlistpoi/${id}`)
          .then(() => {
            const deletedItemOrder = this.items.find((e) => e.id === id).order;
            this.items = this.items.filter((e) => e.id !== id);
            this.items = this.items.map((e) => {
              if (e.order > deletedItemOrder) {
                // eslint-disable-next-line no-param-reassign
                e.order -= 1;
              }
              return e;
            });
            this.updateItemsOrder();
          });
      });
    },

    getTranslationsSubtitle() {
      this.$requestHelpers.post(
        'api/admin/bulk-translations',
        {
          model: this.$constants.TRANSLATION_MODELS.PLAYLIST_SUBTITLE,
          ids: this.items.map((item) => item.id),
        },
      ).then((response) => {
        this.translationsSubtitle = response.data.result;
      });
    },

    getTranslationsTitle() {
      this.$requestHelpers.post(
        'api/admin/bulk-translations',
        {
          model: this.$constants.TRANSLATION_MODELS.PLAYLIST_TITLE,
          ids: this.items.map((item) => item.id),
        },
      ).then((response) => {
        this.translationsTitle = response.data.result;
      });
    },

    sortableRow() {
      if (this.sortBy === 'order' && this.sortDesc === false) {
        this.isSortable = true;
        return 'sortableRow';
      }

      this.isSortable = false;
      return 'nonSortableRow';
    },

    dragReorder(evt) {
      const oldIndex = evt.oldIndex + (this.page - 1) * this.itemsPerPage;
      const newIndex = evt.newIndex + (this.page - 1) * this.itemsPerPage;

      const movedItem = this.items.splice(oldIndex, 1)[0];
      this.items.splice(newIndex, 0, movedItem);
      this.items = this.adjustArrayOrder(this.items);
      this.updateItemsOrder();
    },

    adjustArrayOrder(reorderedArray) {
      return reorderedArray.map((item, key) => {
        // eslint-disable-next-line no-param-reassign
        item.order = key + 1;
        return item;
      });
    },

    isNeedToFixSortedArrayOrder(sortedArray) {
      for (let i = 0; i < sortedArray.length; i += 1) {
        if (i + 1 !== sortedArray[i].order) {
          return true;
        }
      }
      return false;
    },

    updateItemsOrder() {
      this.$requestHelpers
        .post(
          'api/admin/playlistpoi/orderUpdate',
          {
            item_order: this.items.map((item) => ({
              id: item.id,
              order: item.order,
            })),
          },
        )
        .then(() => {
          this.setSnack({
            color: 'green',
            text: 'saved',
          });
        });
    },

    triplePressed(status, item) {
      this.updateItem({ ...item, status }, item);
    },
  },

  computed: {
    maxOrder() {
      return this.items.length;
    },
  },

  directives: {
    sortableDataTable: {
      bind(el, binding, vnode) {
        const options = {
          draggable: '.sortableRow',
          handle: '.sortHandle',
          chosenClass: 'chosen-sortable-row',
          onUpdate(event) {
            vnode.child.$emit('sorted', event);
          },
        };
        Sortable.create(el.getElementsByTagName('tbody')[0], options);
      },
    },
  },
};
</script>

<style lang="css" scoped>
.sortHandle {
  cursor: move;
}
</style>

<style lang="css">
.chosen-sortable-row {
  background-color: #b4e7bf !important;
  display: table-row !important;
}
</style>
